import * as React from "react";

import AbdomenMale from "../../../../assets/organMap/abdomen_male.svg";
import AbdomenFemale from "../../../../assets/organMap/abdomen_female.svg";
import ChestMale from "../../../../assets/organMap/chest_male.svg";
import ChestFemale from "../../../../assets/organMap/chest_female.svg";
import JointFemale from "../../../../assets/organMap/joint_female.svg";
import JointMale from "../../../../assets/organMap/joint_male.svg";
import BackPain from "../../../../assets/organMap/backPain.svg";
import HeadAche from "../../../../assets/organMap/headache.svg";
import SkinMaleFront from "../../../../assets/organMap/skin/skin_male_front.svg";
import SkinMaleBack from "../../../../assets/organMap/skin/skin_male_back.svg";
import SkinFemaleFront from "../../../../assets/organMap/skin/skin_female_front.svg";
import SkinFemaleBack from "../../../../assets/organMap/skin/skin_female_back.svg";
import SkinFace from "../../../../assets/organMap/skin/face.svg";
import SkinLowerLimb from "../../../../assets/organMap/skin/lower_limb.svg";
import LowerLimbMaleFront from "../../../../assets/organMap/lowerLimb/lowerlimb_male_front_FE.8e87394c-d2ba-4326-a54e-ba492fe6df73.svg";
import LowerLimbMaleBack from "../../../../assets/organMap/lowerLimb/lowerlimb_male_back_FE.8e87394c-d2ba-4326-a54e-ba492fe6df73.svg";
import LowerLimbFemaleFront from "../../../../assets/organMap/lowerLimb/lowerlimb_female_front_FE.8e87394c-d2ba-4326-a54e-ba492fe6df73.svg";
import LowerLimbFemaleBack from "../../../../assets/organMap/lowerLimb/lowerlimb_female_back_FE.8e87394c-d2ba-4326-a54e-ba492fe6df73.svg";
import MuscleWeaknessFemale from "../../../../assets/organMap/muscleWeakness/female_FE.52557bdf-69c6-470b-b3d8-5eb775f77f0a.svg";
import MuscleWeaknessMale from "../../../../assets/organMap/muscleWeakness/male_FE.52557bdf-69c6-470b-b3d8-5eb775f77f0a.svg";
import UpperLimbMale from "../../../../assets/organMap/upperLimb/male_FE.f1a3f3be-9ae4-4fa9-b210-070c8718c1ee.svg";
import UpperLimbFemale from "../../../../assets/organMap/upperLimb/female_FE.f1a3f3be-9ae4-4fa9-b210-070c8718c1ee.svg";

import { ReactComponent as AllOverAbdomenChecked } from "../../../../assets/organMap/abdomen_all_over_selected.svg";
import { ReactComponent as AllOverAbdomenUnChecked } from "../../../../assets/organMap/abdomen_all_over_unselected.svg";
import { ReactComponent as AllOverHeadAcheSelected } from "../../../../assets/organMap/headache_all_over_selected.svg";
import { ReactComponent as AllOverHeadAcheUnselected } from "../../../../assets/organMap/headache_all_over_unselected.svg";
import { ReactComponent as SkinMaleAllOverUnselected } from "../../../../assets/organMap/skin/skin_male_all_over_unselected.svg";
import { ReactComponent as SkinMaleAllOverSelected } from "../../../../assets/organMap/skin/skin_male_all_over_selected.svg";
import { ReactComponent as SkinFaceAllOverUnselected } from "../../../../assets/organMap/skin/face_all_over_unselected.svg";
import { ReactComponent as SkinFaceAllOverSelected } from "../../../../assets/organMap/skin/face_all_over_selected.svg";
import { ReactComponent as SkinLowerLimbAllOverUnselected } from "../../../../assets/organMap/skin/lower_limb_all_over_unselected.svg";
import { ReactComponent as SkinLowerLimbAllOverSelected } from "../../../../assets/organMap/skin/lower_limb_all_over_selected.svg";

import { GenderValue } from "shared";
import { CSSProperties } from "@mui/styles";
import { RangeIds } from "../rangeIds";
import { RangeQuestionsMetaData } from "../rangeQuestionsMetaData";

export interface AllOverSettings {
  /***
   * Some areas allow selecting all over the area, if this is set to true
   * the location map will provide a select-all ui whith checkbox
   */
  enabled: boolean;
  /**
   * Some areas have a special feature for all over the area, like abdominal
   * pain, that has General Diffuse
   */
  allOverFeatureId?: string;
  /***
   * If all over text is provided it will be displayed next to the checkbox
   * (and translated using translate(text)
   */
  allOverText?: string;
  /***
   * If icons are provided they will be displayed and togelled instead of the
   * checkbox
   */
  allOverCheckedIcon?: React.ComponentType<any>;
  allOverUnCheckedIcon?: React.ComponentType<any>;
  /**
   * Allows settings the style
   * (location, width height etc of the button using css)
   */
  customContainerStyle?: CSSProperties;
  /***
   * Some areas have multiple maps, this is the displayed text to show
   * on the button to navigate through them (running translate(...) over it)
   */
  subTitle?: string;
}

export enum Orientation {
  // Will show L on the right side, and R on the left side
  Frontal = "frontal",
  // Will shoe L on the left side and R on the right side
  Reverse = "reverse",
  // Will not show any orientation indicators
  Hidden = "hidden",
}

export interface LocationQuestionsMetaData extends RangeQuestionsMetaData {
  // And svg component, with a <path data-feature-id="XX">
  // set for ar least one selectable element.
  // we use the  data-feature-id="XX" attribute to tell on which element the
  // user had clicked on and will add this id to the answer
  // see: https://github.com/kahunmedical/kne.fe/pull/3049 for further explanation
  component: React.ComponentType<any> | any;
  // Is it male/female/unisex
  gender?: LocationMapGender;
  // Does this map has all over settings?
  allOverSettings?: AllOverSettings;
  // Location Subtitle (back, front, side etc..)
  subTitle?: string;
  // If and where to show left and right indicators
  orientation?: Orientation;
}

export const UNISEX = "unisex";

type Unisex = "unisex";

export type LocationMapGender = GenderValue | Unisex;

const createQuestions = ({
  name,
  component,
  gender,
  allOverSettings,
  subTitle,
  rangeId,
  ...props
}: LocationQuestionsMetaData) => ({
  name,
  component,
  gender: gender || UNISEX,
  allOverSettings: allOverSettings || { enabled: false },
  subTitle,
  rangeId,
  orientation: props.orientation || Orientation.Frontal,
  ...props,
});

type CreateAllOverSettingsProps = Omit<AllOverSettings, "enabled">;
const createAllOverSettings = ({
  allOverFeatureId,
  allOverText,
  allOverCheckedIcon,
  allOverUnCheckedIcon,
  customContainerStyle,
}: CreateAllOverSettingsProps) => ({
  enabled: true,
  allOverFeatureId,
  allOverText,
  allOverCheckedIcon,
  allOverUnCheckedIcon,
  customContainerStyle,
});

const abdominalAllOverSettings = createAllOverSettings({
  allOverFeatureId: "FE.a8bd63d7-a369-4e59-8f50-b16e6142fd7a",
  allOverCheckedIcon: AllOverAbdomenChecked,
  allOverUnCheckedIcon: AllOverAbdomenUnChecked,
});

const entireHeadSettings = createAllOverSettings({
  allOverFeatureId: "FE.563c31f5-e4e2-46db-9aab-64d47bba1f57",
  allOverUnCheckedIcon: AllOverHeadAcheUnselected,
  allOverCheckedIcon: AllOverHeadAcheSelected,
  customContainerStyle: {
    width: "89%",
  },
});

const entireMaleSkinSettings = createAllOverSettings({
  allOverFeatureId: "FE.bf8a728c-a9c2-4a0b-bfb6-fca2eee9d48c",
  allOverUnCheckedIcon: SkinMaleAllOverUnselected,
  allOverCheckedIcon: SkinMaleAllOverSelected,
});

const entireFaceSettings = createAllOverSettings({
  allOverFeatureId: "FE.ffc1ab48-43b7-443f-b743-21dcc2c88d96",
  allOverUnCheckedIcon: SkinFaceAllOverUnselected,
  allOverCheckedIcon: SkinFaceAllOverSelected,
});

const entireFaceSkinSettings = createAllOverSettings({
  allOverFeatureId: "FE.b0102754-1c15-4726-88e6-ffd3d58e81e8",
  allOverUnCheckedIcon: SkinFaceAllOverUnselected,
  allOverCheckedIcon: SkinFaceAllOverSelected,
});

const entireLowerLimbSettings = createAllOverSettings({
  allOverFeatureId: "FE.dded53e0-05f1-4761-951f-87999550d59c",
  allOverUnCheckedIcon: SkinLowerLimbAllOverUnselected,
  allOverCheckedIcon: SkinLowerLimbAllOverSelected,
});

export const LocationQuestionsIndex: LocationQuestionsMetaData[] = [
  createQuestions({
    name: "Abdomen Female Location Map",
    component: AbdomenFemale,
    gender: GenderValue.FEMALE,
    allOverSettings: abdominalAllOverSettings,
    rangeId: RangeIds.AbdominalPain,
  }),
  createQuestions({
    name: "Abdomen Male Location Map",
    component: AbdomenMale,
    gender: GenderValue.MALE,
    rangeId: RangeIds.AbdominalPain,
    allOverSettings: abdominalAllOverSettings,
  }),
  createQuestions({
    name: "Chest Female Location Map",
    component: ChestFemale,
    gender: GenderValue.FEMALE,
    rangeId: RangeIds.Chest,
  }),
  createQuestions({
    name: "Chest Male Location Map",
    component: ChestMale,
    gender: GenderValue.MALE,
    rangeId: RangeIds.Chest,
  }),
  createQuestions({
    name: "Joint Male Location Map",
    component: JointMale,
    gender: GenderValue.MALE,
    rangeId: RangeIds.Joint,
  }),
  createQuestions({
    name: "Joint Female Location Map",
    component: JointFemale,
    gender: GenderValue.FEMALE,
    rangeId: RangeIds.Joint,
  }),
  createQuestions({
    name: "Back Pain - Unisex",
    component: BackPain,
    rangeId: RangeIds.Back,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "Headache - Unisex",
    component: HeadAche,
    allOverSettings: entireHeadSettings,
    rangeId: RangeIds.Headach,
    orientation: Orientation.Hidden,
  }),
  createQuestions({
    name: "Skin - Male - Front - EntireSkin",
    gender: GenderValue.MALE,
    subTitle: "LOCATION_FRONT",
    component: SkinMaleFront,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.Skin,
  }),
  createQuestions({
    name: "Skin - Male - Back - EntireSkin",
    gender: GenderValue.MALE,
    subTitle: "LOCATION_BACK",
    component: SkinMaleBack,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.Skin,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "Skin - Female - Front - EntireSkin",
    gender: GenderValue.FEMALE,
    subTitle: "LOCATION_FRONT",
    component: SkinFemaleFront,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.Skin,
  }),
  createQuestions({
    name: "Skin - Female - Back - EntireSkin",
    gender: GenderValue.FEMALE,
    subTitle: "LOCATION_BACK",
    component: SkinFemaleBack,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.Skin,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "Skin - Unisex - Face - EntireSkin",
    component: SkinFace,
    allOverSettings: entireFaceSkinSettings,
    subTitle: "LOCATION_FACE",
    rangeId: RangeIds.Skin,
  }),
  createQuestions({
    name: "Skin - Male - Front - Single",
    gender: GenderValue.MALE,
    subTitle: "LOCATION_FRONT",
    component: SkinMaleFront,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.SkinFrontalArea,
  }),
  createQuestions({
    name: "Skin - Male - Back - Single",
    gender: GenderValue.MALE,
    subTitle: "LOCATION_BACK",
    component: SkinMaleBack,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.SkinBackArea,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "Skin - Female - Front - Single",
    gender: GenderValue.FEMALE,
    subTitle: "LOCATION_FRONT",
    component: SkinFemaleFront,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.SkinFrontalArea,
  }),
  createQuestions({
    name: "Skin - Female - Back - single",
    gender: GenderValue.FEMALE,
    subTitle: "LOCATION_BACK",
    component: SkinFemaleBack,
    allOverSettings: entireMaleSkinSettings,
    rangeId: RangeIds.SkinBackArea,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "Skin - Face",
    component: SkinFace,
    allOverSettings: entireFaceSettings,
    rangeId: RangeIds.SkinFace,
  }),
  createQuestions({
    name: "Skin - Lower Limb",
    component: SkinLowerLimb,
    allOverSettings: entireLowerLimbSettings,
    rangeId: RangeIds.SkinLowerLimb,
  }),
  createQuestions({
    name: "lower limb - general - Male - front",
    gender: GenderValue.MALE,
    component: LowerLimbMaleFront,
    subTitle: "LOCATION_FRONT",
    rangeId: RangeIds.LowerLimb,
  }),
  createQuestions({
    name: "lower limb - general - Male - back",
    gender: GenderValue.MALE,
    component: LowerLimbMaleBack,
    subTitle: "LOCATION_BACK",
    rangeId: RangeIds.LowerLimb,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "lower limb - general - female - front",
    gender: GenderValue.FEMALE,
    component: LowerLimbFemaleFront,
    subTitle: "LOCATION_FRONT",
    rangeId: RangeIds.LowerLimb,
  }),
  createQuestions({
    name: "lower limb - general - female - back",
    gender: GenderValue.FEMALE,
    component: LowerLimbFemaleBack,
    subTitle: "LOCATION_BACK",
    rangeId: RangeIds.LowerLimb,
    orientation: Orientation.Reverse,
  }),
  createQuestions({
    name: "MuscleWeakness - Male",
    gender: GenderValue.MALE,
    component: MuscleWeaknessMale,
    rangeId: RangeIds.MuscleWeakness,
  }),
  createQuestions({
    name: "MuscleWeakness - Female",
    gender: GenderValue.FEMALE,
    component: MuscleWeaknessFemale,
    rangeId: RangeIds.MuscleWeakness,
  }),
  createQuestions({
    name: "UpperLimb - Male",
    gender: GenderValue.MALE,
    component: UpperLimbMale,
    rangeId: RangeIds.UpperLimb,
  }),
  createQuestions({
    name: "UpperLimb - Female",
    gender: GenderValue.FEMALE,
    component: UpperLimbFemale,
    rangeId: RangeIds.UpperLimb,
  }),
];
